// AI 가 자료를 찾고 읽는 단계 — status 청크의 steps 를 이번 답변의 단계 목록에 쌓는다.
// 서버: backend/services/chat_tools/registry.py progress_event (message 는 진행 중, done 은 끝난 뒤 문구).
export const ACTIVITY_STEPS_MAX = 8;

const text = (value) => (typeof value === 'string' ? value.trim() : '');

export const normalizeActivitySteps = (steps) => (Array.isArray(steps) ? steps : [])
  .map((step) => ({
    type: text(step?.status_type ?? step?.type),
    message: text(step?.message),
    done: text(step?.done),
    detail: text(step?.detail),
  }))
  .filter((step) => step.message);

const sameStep = (a, b) => a.message === b.message && a.detail === b.detail;

export const appendActivitySteps = (current, steps) => {
  const next = Array.isArray(current) ? [...current] : [];
  steps.forEach((step) => {
    if (!next.some((seen) => sameStep(seen, step))) next.push(step);
  });
  return next.slice(-ACTIVITY_STEPS_MAX);
};

/** 지금 진행 중인 단계(현재 상태와 같은 마지막 단계)를 빼고 끝난 단계만. */
export const finishedActivitySteps = (steps, currentStatus) => {
  const list = Array.isArray(steps) ? steps : [];
  const last = list[list.length - 1];
  const running = last && currentStatus?.message === last.message && (currentStatus?.detail || '') === last.detail;
  return running ? list.slice(0, -1) : list;
};
